import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
import { useOnboardingStore } from '../stores/onboardingStore'
import type { TOnboardingSection } from '../types/TOnboardingSection'

/**
 * Пока идёт онбординг раздела, ставит демо-записи первыми в отображаемый список таблицы.
 * Стор модуля не меняется, поэтому реальные записи и realtime-обновления не затрагиваются,
 * а демо-запись видна на первой странице независимо от пагинации.
 */
export function useOnboardingDemoRows<T extends { id?: number | string | null }>(
  section: TOnboardingSection,
  items: Ref<T[]> | ComputedRef<T[]>,
) {
  const onboardingStore = useOnboardingStore()

  const demoRows = computed<T[]>(() => {
    if (onboardingStore.scenario?.section !== section)
      return []

    return onboardingStore.activeDemoItems.map(item => item.list as T)
  })

  const demoIds = computed(() => new Set(demoRows.value.map(row => String(row.id))))

  const rows = computed<T[]>(() => {
    if (!demoRows.value.length)
      return items.value

    return [...demoRows.value, ...items.value.filter(item => !demoIds.value.has(String(item.id)))]
  })

  const isDemoRow = (item: { id?: number | string | null }) => demoIds.value.has(String(item.id))

  return { rows, isDemoRow }
}
